import React, {ReactElement} from 'react';
import Heading, {HEADING_TYPES} from '@frontend/ui-kit/Components/Heading';
import Text, {TEXT_TYPES} from '@frontend/ui-kit/Components/Text';
import Row from '@frontend/ui-kit/Components/Row';
import Column from '@frontend/ui-kit/Components/Column';
import ContentSection from '@frontend/ui-kit/Components/ContentSection';
import Link from '@frontend/ui-kit/Components/Link';
import styles from './index.module.scss';
import HJLogo from '../../../static/images/HJLogo.svg';
import girlWithPaper from '../../../static/images/girlWithPaper.svg';
import chromeIcon from '../../../static/images/chromeIcon.svg';
import edgeIcon from '../../../static/images/edgeIcon.svg';
import firefoxIcon from '../../../static/images/firefoxIcon.svg';
import safariIcon from '../../../static/images/safariIcon.svg';
import {RecommendedBrowser} from './types';

const RECOMMENDED_BROWSERS: Array<RecommendedBrowser> = [
    {name: 'Chrome', logo: chromeIcon, link: 'https://www.google.com/chrome'},
    {name: 'Edge', logo: edgeIcon, link: 'https://www.microsoft.com/en-us/edge'},
    {name: 'Firefox', logo: firefoxIcon, link: 'https://www.mozilla.org/en-US/firefox/new'},
    {name: 'Safari', logo: safariIcon, link: 'https://support.apple.com/downloads/safari'}
];

const IESunsetLayout = (): ReactElement => {
    return (
        <div className={styles.IESunsetLayout}>
            <div className={styles.header}>
                <img className={styles.HJLogo} src={HJLogo} alt=''/>
            </div>

            <div className={styles.content}>
                <div className={styles.info}>
                    <img className={styles.infoImage} src={girlWithPaper} alt=''/>

                    <Heading className={styles.title} type={HEADING_TYPES['1']} fontWeight='semibold'>
                        Oh no! Your browser is no longer supported!
                    </Heading>

                    <Text className={styles.description}>
                        We're sorry, but we no longer support your browser (Internet Explorer).
                        To continue using the HealthJoy Dashboard you'll need to access it via a different web browser.
                    </Text>
                    <Text className={styles.recommendation}>We recommend,</Text>
                </div>

                <Row className={styles.supportedBrowsers}>
                    {RECOMMENDED_BROWSERS.map(({name, logo, link}: RecommendedBrowser): ReactElement => {
                        return (
                            <Column key={name} sm={3}>
                                <ContentSection className={styles.recommendedBrowser}>
                                    <Link className={styles.browserLink} href={link} target='_blank' rel='noreferrer'>
                                        <img className={styles.browserLogo} src={logo} alt=''/>
                                        <Text className={styles.browserName} type={TEXT_TYPES.caption}>{name}</Text>
                                    </Link>
                                </ContentSection>
                            </Column>
                        );
                    })}
                </Row>
            </div>

            <div className={styles.footer}>
                <Text>© HealthJoy</Text>
            </div>
        </div>
    );
};

export {IESunsetLayout as TestableIESunsetLayout};
export default IESunsetLayout;
